import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid' // Import timeGridPlugin for week and day views
import interactionPlugin from '@fullcalendar/interaction'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { TELEMEDICINE_DOMAIN } from "../../../../../utils/telemedicine/domain";
import { useContext, useEffect, useRef, useState } from "react";
import FullCalendar from '@fullcalendar/react'
// import dayGridPlugin from '@fullcalendar/daygrid'
// import interactionPlugin from "@fullcalendar/interaction"
import { ArrowLeft, ArrowLeft2, ArrowRight, ArrowRight2, Book, Call, CallRemove, Category, DocumentText1, Edit, Grid1, MessageMinus, Microphone2, More, More2, Profile2User, Sms, User, UserAdd, Video, VideoAdd } from "iconsax-react";
import { MeetingContext } from "../../context/MeetingContext";
import { useLoaderData, useNavigate } from "react-router-dom";
import instance from "../../../../../axios/instance";
import { toast } from "react-toastify";
import { SocketContext } from '../../context/SocketContext';
import { X } from 'lucide-react';
import BasicDateTimePicker from '../../../../../components/calendar/Calendar';
import { getToken } from '../../../../../utils/token';
import MyCalendar from '../../compomnents/MyCalendar';


export default function TeleCalendar() {
    const navigate = useNavigate();
    const calendarRef = useRef(null);

    const [currentDate, setCurrentDate] = useState(new Date());
    const [formattedDate, setFormattedDate] = useState(() => {
        return currentDate.toLocaleString('default', { month: 'long', year: 'numeric' });
    });
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [meetings, setMeetings] = useState([]);
    const [calendarView, setCalendarView] = useState('dayGridMonth');
    const [inviteOpen, setInviteOpen] = useState({
        open: false,
        date: ""
    })

    function handleEventClick(event) {
        setEvent(event.event);
    }

    const token = window.sessionStorage.getItem("ACCESS_TOKEN");

    async function getMeetings() {
        setLoading(true);
        instance
            .get("/telemedicine/doctor/meetings", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((response) => {
                console.log(response.data);
                const meetings = response.data;

                const formattedMeetings = meetings.map((meeting) => ({
                    id: meeting.id,
                    title: meeting.meeting_title,
                    start: new Date(meeting.start),
                    end: new Date(meeting.end),
                    extendedProps: {
                        channel_name: meeting.channel_name,
                        patient_id: meeting.patient_id,
                        patient_name: meeting.patient_name,
                        meeting: {
                            id: meeting.id,
                            start: meeting.start,
                            end: meeting.end,
                            patient_id: meeting.patient_id,
                            patient_name: meeting.patient_name,
                            doctor_id: meeting.doctor_id,
                            doctor_name: meeting.doctor_name,
                            meeting_title: meeting.meeting_title,
                            channel_name: meeting.channel_name,
                            meeting_status: meeting.meeting_status,
                            created_at: meeting.created_at,
                            is_doctor_present: meeting.is_doctor_present,
                            is_patient_present: meeting.is_patient_present,
                        },
                    },
                }));

                setMeetings(formattedMeetings);
                setLoading(false);
            })
            .catch((error) => {
                toast.error(error.response?.data?.message || "Failed to fetch meetings", {
                    position: "bottom-right",
                });
                setLoading(false);
            });
    }

    const handleViewChange = (view) => {
        setCalendarView(view);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.changeView(view);
        setCurrentDate(calendarApi.getDate()); // Update currentDate when view changes
    };

    const handleNext = () => {
        const calendarApi = calendarRef.current.getApi();
        calendarApi.next();
        setCurrentDate(calendarApi.getDate()); // Update currentDate after navigating
    };

    const handlePrev = () => {
        const calendarApi = calendarRef.current.getApi();
        calendarApi.prev();
        setCurrentDate(calendarApi.getDate()); // Update currentDate after navigating
    };

    useEffect(() => {
        getMeetings();
    }, []);

    useEffect(() => {
        // Update formattedDate whenever currentDate changes
        setFormattedDate(currentDate.toLocaleString('default', { month: 'long', year: 'numeric' }));
    }, [currentDate]);

    if (loading) {
        return <div />;
    }

    return (
        <div className="p-6 space-y-3">
            <div className="border">
                <div className="p-3 border-b flex justify-between items-center">
                    <div className="font-medium text-[17px]">{formattedDate}</div> {/* This date here */}

                    <div className="flex gap-3 items-center">

                        <select
                            className="border-none text-[#00b0ad] font-medium px-3 py-2 text-[14px] outline-none"
                            value={calendarView}
                            onChange={(e) => handleViewChange(e.target.value)}
                        >
                            <option value="dayGridMonth">Month view</option>
                            <option value="timeGridWeek">Week view</option>
                            <option value="timeGridDay">Day view</option>
                        </select>



                        <button
                            onClick={() => navigate("/dashboard/telemedicine/calendar/availability")}
                            className="px-4 py-2 flex items-center gap-2 bg-[#00b0ad] rounded-[4px] text-white font-medium text-[14px]"
                        >
                            <Edit size={18} />
                            Edit availability
                        </button>

                        <div className="flex items-center gap-1">
                            <button onClick={handlePrev} className="px-4 bg-[#00b0ad] text-white rounded-[4px] py-2 flex justify-center items-center">
                                <ArrowLeft2 variant='Bold' size={20} />
                            </button>
                            <button onClick={handleNext} className="px-4 bg-[#00b0ad] text-white rounded-[4px] py-2 flex justify-center items-center">
                                <ArrowRight2 variant='Bold' size={20} />
                            </button>
                        </div>
                    </div>
                </div>
                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    initialView={calendarView}
                    weekends={true}
                    events={meetings}
                    height={600}
                    ref={calendarRef}
                    eventClick={handleEventClick}
                    dateClick={(date) => setInviteOpen({ open: true, date: date })}
                    headerToolbar={false}
                />

                {
                    inviteOpen.open && <InviteComponent complete={data => {
                        if (data) {
                            setInviteOpen(false)
                            window.location.reload();
                        }
                    }} data={inviteOpen} onClose={() => setInviteOpen(false)} />
                }

                {!event ? null : <EventComponent event={event} onClose={() => setEvent(null)} />}
            </div>
        </div>
    );
}

function InviteComponent({ data, onClose, complete }) {

    //console.log(data.date.date);



    const patients = useLoaderData()



    function formatDate(dateInput) {
    const format = (date) => {
        const weekday = date.toLocaleString('en-US', { weekday: 'short' });
        const month = date.toLocaleString('en-US', { month: 'long' });
        const day = date.getDate();
        const year = date.getFullYear();
        const time = date.toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });

        return `${weekday}, ${month} ${day}, ${year}, ${time}`;
    };

    const startDate = new Date(dateInput);
    const endDate = new Date(startDate.getTime() + 30 * 60 * 1000); // Add 30 minutes

    return {
        start: format(startDate),
        end: format(endDate)
    };
}



    // console.log(formatDate(date));

    const [loading, setLoading] = useState(false)
    const [patient, setPatient] = useState()

    async function sendInvite() {

        console.log(patient);

        instance.post("/telemedicine/doctor/meeting/send-invite", {
            start: formatDate(new Date(data.date.date)).start,
            end: formatDate(new Date(data.date.date)).end,
            patient_id: patient,
        }, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
            .then(response => {
                console.log(response.data);
                toast.success(response.data.message)
                complete(true)
            })
            .catch(error => {
                console.log(error);
                toast.error(error.response.data.message)
            })
    }


    return (
        <div className="fixed top-0 bottom-0 right-0 left-0 z-[100] flex justify-center items-center bg-[#11111180]">
            <div className="bg-white w-[450px] rounded-[8px]">
                <div className="flex justify-between items-start p-3 border-b">
                    <div>
                        <div className="font-semibold text-[15px] text-gray-900">Send invitation</div>
                        <div className="text-sm font-light text-gray-600">Select a date to invite a patient</div>
                    </div>

                    <button onClick={onClose}>
                        <X size={22} color="black" />
                    </button>
                </div>

                <div className="px-3 space-y-3 flex flex-col pt-3 pb-6">
                    <div className="flex justify-between items-center border border-gray-600 text-gray-600 rounded-[8px] p-3 text-sm">
                        <div>Selected date</div>

                        <div>{formatDate(new Date(data.date.date)).start}</div>
                    </div>


                    <select onChange={e => setPatient(e.target.value)} className="flex justify-between items-center border border-gray-600 text-gray-600 rounded-[8px] p-3 text-sm">
                        <option value="">Select a patient</option>
                        {
                            patients?.data.map(patient => (
                                <option value={patient.id} key={patient.id}>{patient.firstname} {patient.lastname}</option>
                            ))
                        }
                    </select>

                    <button disabled={loading} onClick={sendInvite} className="bg-[#00b0ad] text-sm rounded-[8px] font-medium text-white p-3">
                        {
                            loading ? "Loading..." : "Send invititation"
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}

function EventComponent({ event, onClose }) {


    const navigate = useNavigate()

    const socket = useContext(SocketContext)

    const [open, setOpen] = useState(false);

    const monthString = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]

    const daysString = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]


    const start = new Date(event.start)
    const end = new Date(event.end)

    const { setMeetingData } = useContext(MeetingContext)

    const [openRescheduleModal, setOpenRescheduleModal] = useState(false)

    console.log(event);

    function handleDoctorJoin(meetingData) {
        console.log(meetingData);

        socket.emit("doctor_join", { meeting: meetingData })

        // socket.emit("meeting_check", { meeting: { id: 2 }})

        socket.on("doctor_joined", data => {

            console.log(data);

            navigate("/dashboard/telemedicine/meeting", { state: data })
        })


        // change patient data to meeting data

    }

    return (
        <>
            {
                openRescheduleModal &&
                <RescheduleComponent
                    onClose={() => setOpenRescheduleModal(false)}
                    meetingData={event}
                    onComplete={data => {
                        if (data) {
                            setOpenRescheduleModal(false)
                        }
                    }}
                />
            }
            <div className="fixed top-0 bottom-0 right-0 w-[400px] border-l bg-white z-50">
                <div className="flex justify-between items-center p-3 border-b border-gray-200 sticky left-0 right-0 top-0 z-50 bg-white">
                    <div className="font-medium">Appointment</div>
                    <button onClick={onClose}>
                        <X color="black" width="20px" height="20px" />
                    </button>
                </div>

                <div className="p-3 space-y-4">
                    {/* <button onClick={() => setOpen(true)}>Open meeting</button> */}
                    <div className="text-[16px] font-medium">{event.title}</div>

                    <div className="flex gap-3 items-center">
                        <div className="bg-gray-200 w-12 h-12 flex flex-col justify-center items-center rounded-[4px]">
                            <div className="font-semibold text-[14px]">{start.getDate()}</div>
                            <div className="text-[14px]">{monthString[start.getMonth()]}</div>
                        </div>

                        <div>
                            <div>{daysString[start.getDay()]}</div>
                            <div>{formatTime(start.getTime())} - {formatTime(end.getTime())}</div>
                        </div>
                    </div>

                    <div className="border-t py-3">
                        <div className="text-[14px] text-gray-500 mb-3">Patient Information</div>

                        <div className="flex gap-3 items-center">
                            <div className="w-12 h-12 flex justify-center rounded-[4px] items-center bg-gray-200">
                                <User size={20} variant="Bold" />
                            </div>
                            <div>
                                <div className="font-medium text-[15px]">{event.extendedProps.patient_name}</div>
                                <div className="text-[12px] font-medium text-gray-500">UID: {event.extendedProps.patient_id}</div>
                            </div>



                        </div>

                        <div className='my-2 flex gap-2'>
                            <button onClick={() => handleDoctorJoin(event.extendedProps.meeting)} className="px-3 py-2 font-medium text-[14px] text-white rounded-[6px] bg-[#00b0ad]">Join now</button>
                            <button onClick={() => setOpenRescheduleModal(true)} className="px-3 py-2 font-medium text-[14px] text-[#00b0ad] bg-white border  rounded-[6px] border-[#00b0ad]">Reschedule appointment</button>
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

function RescheduleComponent({ onClose, meetingData, onComplete }) {

    console.log("meet data ", meetingData?.extendedProps);

    const data = meetingData?.extendedProps?.meeting
    const [loading, setLoading] = useState(false)

    const [newSchedule, setNewSchedule] = useState()

    async function handleReschedule() {
        setLoading(true)
        instance.post("/doctor/meeting/reschedule", {
            new_schedule: newSchedule,
            meeting_id: data.id
        }, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
            .then(response => {
                console.log(response.data);
                onComplete(true)
                toast.success("Reshedule notification sent to patient")
                setLoading(false)
            })
            .catch(error => {
                console.log(error.response.data);
                toast.error(error.response.data.message)
                setLoading(false)
            })
    }

    return (
        <div className="fixed top-0 bottom-0 right-0 left-0 z-[100] flex justify-center items-center bg-[#11111180]">
            <div className="bg-white w-[450px] rounded-[8px]">
                <div className="flex justify-between items-start p-3 border-b">
                    <div>
                        <div className="font-semibold text-[15px] text-gray-900">Reschedule appointment</div>
                        <div className="text-sm font-light text-gray-600">Select a new date to reschedule appointment</div>
                    </div>

                    <button onClick={onClose}>
                        <X size={22} color="black" />
                    </button>
                </div>

                <div className="px-3 space-y-3 flex flex-col pt-3 pb-6">
                    <div className="flex justify-between items-center border border-gray-600 text-gray-600 rounded-[8px] p-3 text-sm">
                        <div>Current schedule</div>

                        <div>{data.start}</div>
                    </div>


                    <BasicDateTimePicker onChange={(value => setNewSchedule(value.$d))} />

                    <button disabled={loading} onClick={handleReschedule} className="bg-[#00b0ad] text-sm rounded-[8px] font-medium text-white p-3">
                        {
                            loading ? "Rescheduling..." : "Reschedule appointment"
                        }
                    </button>
                </div>


            </div>
        </div>
    )
}

// meeting modal to be used accross all web platforms
function MeetModal({ roomName, onClose }) {

    const { setMeetingData } = useContext(MeetingContext)

    const [api, setApi] = useState(null)
    return (
        <div className="fixed top-0 flex flex-col left-0 right-0 bottom-0 z-[100] bg-[#040404]">
            {/* <div className="p-3 flex justify-end">
                <button onClick={onClose} className="w-11 h-11 rounded-full bg-red-500 flex justify-center items-center">
                    <CloseOutline width="24px" height="24px" color="#fff" />
                </button>
            </div> */}


        </div>
    )
}



function formatTime(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
};